import styled from 'styled-components'

export const Container = styled.div`
  .footer {
    &__fqa {
      line-height: 1.4;

      li {
        &:not(.footer__fqa-more) {
          font-size: 14px;
          padding-bottom: 10px;
          margin-bottom: 10px;
          border-bottom: 1px solid;
        }
      }

      &-more {
        margin-top: 22px;

        a {
          text-decoration: underline;
        }
      }
    }
  }
`
